import styled from 'styled-components';
import StatusLabel from '@sdk/components/ui/StatusLabel';

export const CustomStatusLabel = styled(StatusLabel)`
  height: 22px;
  width: 80px;
  padding: 3px 11px 2px 11px;
`;

export const PremiumGuardInlineContainer = styled.span`
  display: inline-block;
`;
